export async function fetchShopDetailOption(
  slug: string,
  lang: string,
): Promise<any> {
  const res = await fetch(
    `${process.env.NEXT_PUBLIC_API_URL}/api/shops/${slug}/option?lang=${lang}`,
    {},
  );

  if (!res.ok) {
    return undefined;
  }

  return await res.json();
}
